export enum AppRoute {

    WELCOME = "WELCOME",
    SSO = "SSO",
    OPS = "OPS",

    ON_BOARD = "ON_BOARD",

    HOME = "HOME",

    INVOICE = "INVOICE",

    CATALOG = "CATALOG",
    PRODUCT = "PRODUCT",

    BOOSTS = "BOOSTS",
    BOOST = "BOOST",

    CONTACTS = "CONTACTS",
    HOW_TO = "HOW_TO",
    FAQS = "FAQS",

    PROFILE = "PROFILE",
    REWARDS_HISTORY = "REWARDS_HISTORY",
    POINTS_HISTORY = "POINTS_HISTORY",
    INVOICES_HISTORY = "INVOICES_HISTORY",

    COOKIE_POLICY = "COOKIE_POLICY",

    ERROR_404 = "ERROR_404",
    LOGOUT = "LOGOUT",
    DEBUG = "DEBUG",
}

export type RouteParams = {
    [AppRoute.WELCOME]: undefined;
    [AppRoute.OPS]: undefined;
    [AppRoute.SSO]: undefined;

    [AppRoute.ON_BOARD]: undefined;
    [AppRoute.HOME]: undefined;

    [AppRoute.INVOICE]: undefined;

    [AppRoute.CATALOG]: undefined;
    [AppRoute.PRODUCT]: { productId: string|number };

    [AppRoute.BOOSTS]: undefined;
    [AppRoute.BOOST]: { boostId: string|number };

    [AppRoute.CONTACTS]: undefined;
    [AppRoute.HOW_TO]: undefined;
    [AppRoute.FAQS]: undefined;

    [AppRoute.PROFILE]: undefined;
    [AppRoute.REWARDS_HISTORY]: undefined;
    [AppRoute.POINTS_HISTORY]: undefined;
    [AppRoute.COOKIE_POLICY]: undefined;

    [AppRoute.ERROR_404]: undefined;
    [AppRoute.LOGOUT]: undefined;
    [AppRoute.DEBUG]: undefined;
};

export const RoutePath: Record<AppRoute, string> = {

    [AppRoute.WELCOME]: "/welcome",
    [AppRoute.SSO]: "/",
    [AppRoute.OPS]: "/ops",

    [AppRoute.ON_BOARD]: "/auth/on-board",
    [AppRoute.HOME]: "/home",

    [AppRoute.INVOICE]: "/invoice",

    [AppRoute.PRODUCT]: "/catalog/products/:productId",
    [AppRoute.CATALOG]: "/catalog",

    [AppRoute.BOOSTS]: "/boosts",
    [AppRoute.BOOST]: "/boosts/:boostId",

    [AppRoute.CONTACTS]: "/contacts",
    [AppRoute.HOW_TO]: "/how-to",
    [AppRoute.FAQS]: "/faqs",

    [AppRoute.PROFILE]: "/profile",
    [AppRoute.REWARDS_HISTORY]: "/history/rewards",
    [AppRoute.POINTS_HISTORY]: "/history/points",
    [AppRoute.INVOICES_HISTORY]: "/history/invoices",

    [AppRoute.COOKIE_POLICY]: "/cookies",

    [AppRoute.LOGOUT]: "/logout",
    [AppRoute.DEBUG]: "/debug",
    [AppRoute.ERROR_404]: "*",
};
